exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".banner[_v-2e890e9e]{padding-bottom:40%;margin-bottom:40px;margin-top:0;background-attachment:fixed;background-position:50%;background-size:cover}.banner.banner-media[_v-2e890e9e]{background-image:url(" + require("../../images/news/2-3_3_News_Media.jpg") + ")}.banner.banner-circular[_v-2e890e9e]{background-image:url(" + require("../../images/news/2-3_3_News_circulars.jpg") + ")}.banner.banner-announcement[_v-2e890e9e]{background-image:url(" + require("../../images/news/2-3_3_News_Announcement.jpg") + ")}.banner.banner-financial[_v-2e890e9e]{background-image:url(" + require("../../images/news/2-3_3_News_Fin_report.jpg") + ")}@media (max-width:767px){.banner[_v-2e890e9e]{height:0;padding-bottom:52%}#news-view-content[_v-2e890e9e]{margin-top:53px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-2e890e9e&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./assets/component/news/news-page.vue
// module id = 295
// module chunks = 0